import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import SideBar from "../components/sidebar/sidebar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  STUDENT_HOME_URL,
  TEACHER_JOURNEY_URL,
  TEACHER_ROLE,
  teacherRouteConfig,
} from "../constants";
import "./TeacherLayout.css";
import TeacherProfileProgressAlert from "../components/teacherHeader/profile-progress-bar";
import useWebSocket from "../helper/use-web-socket";
import TeacherMeetingAlert from "../components/sessions-alert";
import CommonHeader from "../components/HeaderCommon";

const TeacherLayout = ({ children }) => {
  const currentUser = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const { isConnected } = useWebSocket();

  useEffect(() => {
    if (currentUser === null) {
      navigate("/");
    } else if (currentUser?.role && currentUser?.role !== TEACHER_ROLE) {
      navigate(STUDENT_HOME_URL);
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarVisible(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // console.log(`WebSocket ${isConnected ? "connected" : "disconnected"}`);
  }, [isConnected, currentUser]);

  return (
    <div className="teacher-layout">
      {isSidebarVisible && <SideBar routeConfig={teacherRouteConfig} />}
      <div className="content-wrapper">
        <CommonHeader />
        <TeacherProfileProgressAlert />
        <TeacherMeetingAlert />
        <div className="content-container">
          <main>
            <div className="main_standard" style={{ minHeight: "90vh" }}>
              {children}
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default TeacherLayout;
